@if (formHeader) {
  <div class="mt-form-header pb-10">
    <div class="mt-hdr">
      <p class="mt-hdr-title">{{ formHeader }}</p>
      <span class="sp"></span>
      <mt-btn class="icon error" (onAction)="onClose('close')">
        <mat-icon>clear</mat-icon>
      </mt-btn>
    </div>
  </div>
}

<form #mtCommonForm="ngForm">
  <div class="mt-form-body">
    <div class="row">
      @if (formFields.length > 0) {
        @for (formField of formFields; track formField; let i = $index) {
          <div [ngClass]="$safeNavigationMigration(formField?.class) + ' with-gutter'">
            @if (formField.type === 'text') {
              <div class="mb-10">
                @if (label && formField?.name !== '') {
                  <div
                    class="input-title"
                  [ngStyle]="{
                    'padding-left': i % formField.cols == 0 ? '0' : '10px'
                  }"
                    >
                    <span>{{ formField?.name }}</span>
                  </div>
                }
                <mat-form-field class="col-md-2 moneytor-input">
                  <mat-label>{{ formField.name }}</mat-label>
                  <div>
                    <textarea
                      matInput
                      [rows]="queryRow"
                      [cols]="50"
                      [(ngModel)]="postObj[formField.model]"
                      [placeholder]="formField.placeHolder"
                      [name]="formField.name"
                      [required]="formField.required"
                      #fIndex="ngModel"
                      [type]="formField.inputType"
                      [pattern]="formField.pattern"
                    ></textarea>
                    @if (fIndex.invalid && fIndex.touched) {
                      <div>
                        @if (fIndex.hasError('pattern')) {
                          <mat-error
                            >Please enter valid {{ formField.name }}</mat-error
                            >
                          }
                          @if (fIndex.hasError('required')) {
                            <mat-error
                              >{{ formField.name }} is required*</mat-error
                              >
                            }
                          </div>
                        }
                      </div>
                    </mat-form-field>
                  </div>
                }
                @if (formField.type === 'input') {
                  <div class="mb-10">
                    @if (label && formField?.name !== '') {
                      <div
                        class="input-title"
                  [ngStyle]="{
                    'padding-left': i % formField.cols == 0 ? '0' : '10px'
                  }"
                        >
                        <span>{{ formField?.name }}</span>
                      </div>
                    }
                    <mat-form-field class="col-md-2 moneytor-input">
                      <mat-label>{{ formField.name }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="postObj[formField.model]"
                        [placeholder]="formField.placeHolder"
                        [name]="formField.name"
                        [required]="formField.required"
                        #fIndex="ngModel"
                        [type]="formField.inputType"
                        [pattern]="formField.pattern"
                        />
                      @if (fIndex.invalid && fIndex.touched) {
                        <div>
                          @if (fIndex.hasError('pattern')) {
                            <mat-error
                              >Please enter valid {{ formField.name }}</mat-error
                              >
                            }
                            @if (fIndex.hasError('required')) {
                              <mat-error
                                >{{ formField.name }} is required*</mat-error
                                >
                              }
                            </div>
                          }
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'email') {
                      <div class="mb-10">
                        @if (label) {
                          <div
                            class="input-title"
                  [ngStyle]="{
                    'padding-left': i % formField.cols == 0 ? '0' : '10px'
                  }"
                            >
                            <span>{{ formField.name }}</span>
                          </div>
                        }
                        <mat-form-field class="col-md-2 moneytor-input">
                          <mat-label>{{ formField.name }}</mat-label>
                          <input
                            matInput
                            [name]="formField.name"
                            [(ngModel)]="postObj[formField.model]"
                            [placeholder]="formField.placeHolder"
                            [type]="formField.type"
                            [pattern]="formField.pattern"
                            #fIndex="ngModel"
                            [disabled]="formField.disabled"
                            [required]="formField.required"
                            />
                          @if (fIndex.invalid && fIndex.touched) {
                            <div>
                              @if (fIndex.hasError('pattern')) {
                                <mat-error
                                  >Please enter valid {{ formField.name }}</mat-error
                                  >
                                }
                                @if (fIndex.hasError('required')) {
                                  <mat-error
                                    >{{ formField.name }} is required*</mat-error
                                    >
                                  }
                                </div>
                              }
                            </mat-form-field>
                          </div>
                        }
                        @if (formField.column && formField.column === 'fieldJSON1') {
                          @if (formField.type === 'select') {
                            <div class="mb-10">
                              @if (label) {
                                <div
                                  class="input-title"
                    [ngStyle]="{
                      'padding-left': i % formField.cols == 0 ? '0' : '10px'
                    }"
                                  >
                                  <span>{{ formField.name }}</span>
                                </div>
                              }
                              <mat-form-field
                                appearance="outline"
                                class="col-md-2 moneytor-input"
                                >
                                <mat-select
                                  [placeholder]="formField.name"
                                  [name]="formField.name"
                                  [required]="formField.required"
                                  [(ngModel)]="postObj.fieldJSON1[formField.model]"
                                  #fIndex="ngModel"
                                  [disabled]="formField.disabled"
                                  (selectionChange)="onDropDownChange(formField, i, $event)"
                                  >
                                  @for (option of formField.options; track option) {
                                    <mat-option
                        [value]="
                          formField.value ? option[formField.value] : option
                        "
                                      >
                                      {{
                                      formField.display ? option[formField.display] : option
                                      }}
                                    </mat-option>
                                  }
                                </mat-select>
                                @if (fIndex.invalid && fIndex.touched) {
                                  <div>
                                    @if (fIndex.hasError('required')) {
                                      <mat-error
                                        >{{ formField.name }} is required*</mat-error
                                        >
                                      }
                                    </div>
                                  }
                                </mat-form-field>
                              </div>
                            }
                          }
                          @if (!formField.column && formField.column !== 'fieldJSON1') {
                            @if (formField.type === 'select') {
                              <div class="mb-10">
                                @if (label) {
                                  <div
                                    class="input-title"
                    [ngStyle]="{
                      'padding-left': i % formField.cols == 0 ? '0' : '10px'
                    }"
                                    >
                                    <span>{{ formField.name }}</span>
                                  </div>
                                }
                                <mat-form-field
                                  appearance="outline"
                                  class="col-md-2 moneytor-input"
                                  >
                                  <mat-select
                                    [placeholder]="formField.name"
                                    [name]="formField.name"
                                    [required]="formField.required"
                                    [(ngModel)]="postObj[formField.model]"
                                    #fIndex="ngModel"
                                    [disabled]="formField.disabled"
                                    (selectionChange)="onDropDownChange(formField, i, $event)"
                                    [multiple]="formField.multiple"
                                    #filterSelect="ngModel"
                                    >
                                    @if (formField.multiple) {
                                      <mt-select-all
                                        [model]="filterSelect"
                                        [values]="formField.options"
                                        (onSelectAll)="onSelectAll($event)"
                                        >
                                      </mt-select-all>
                                    }
                                    @for (option of formField.options; track option) {
                                      <mat-option
                        [value]="
                          formField.value ? option[formField.value] : option
                        "
                                        >
                                        {{
                                        formField.display ? option[formField.display] : option
                                        }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                  @if (fIndex.invalid && fIndex.touched) {
                                    <div>
                                      @if (fIndex.hasError('required')) {
                                        <mat-error
                                          >{{ formField.name }} is required*</mat-error
                                          >
                                        }
                                      </div>
                                    }
                                  </mat-form-field>
                                </div>
                              }
                            }
                            @if (formField.column && formField.column == 'relations') {
                              @if (formField.type === 'select') {
                                @for (row of postObj.relations; track row; let i = $index) {
                                  <div>
                                    <div class="mb-10">
                                      @if (label) {
                                        <div
                                          class="input-title"
                      [ngStyle]="{
                        'padding-left': i % formField.cols == 0 ? '0' : '10px'
                      }"
                                          >
                                          <span>{{ formField.name }}</span>
                                        </div>
                                      }
                                      <!-- <div class="d-flex m-auto" *ngIf="formField.name == 'BaseConfigs' && i == 0 ">previous</div> -->
                                      <mat-form-field
                                        appearance="outline"
                                        class="col-md-2 moneytor-input"
                                        >
                                        <mat-select
                                          [placeholder]="formField.name"
                                          [name]="formField.name + [i]"
                                          [required]="formField.required"
                                          [(ngModel)]="postObj['relations'][i][formField.model]"
                                          #fIndex="ngModel"
                                          #filterSelect="ngModel"
                                          >
                                          <!-- <ng-container *ngIf="formField.multiple">
                                          <mt-select-all [model]="filterSelect" [values]="formField.options" (onSelectAll)="onSelectAll($event)"> </mt-select-all>
                                        </ng-container> -->
                                        @for (option of formField.options; track option) {
                                          <mat-option
                          [value]="
                            formField.value ? option[formField.value] : option
                          "
                                            >
                                            {{
                                            formField.display
                                            ? option[formField.display]
                                            : option
                                            }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                      @if (fIndex.invalid && fIndex.touched) {
                                        <div>
                                          @if (fIndex.hasError('required')) {
                                            <mat-error
                                              >{{ formField.name }} is required*</mat-error
                                              >
                                            }
                                          </div>
                                        }
                                      </mat-form-field>
                                    </div>
                                  </div>
                                }
                              }
                            }
                            <!-- <ng-container *ngIf="formField.type === 'select'">
                            <div fxLayout="row" fxFlex="100%" class="mb-10">
                              <div class="input-title" *ngIf="label" [ngStyle]="{ 'padding-left': i % formField.cols == 0 ? '0' : '10px' }">
                                <span>{{ formField.name }}</span>
                              </div>
                              <mat-form-field appearance="outline" class="col-md-2 moneytor-input">
                                <mat-label>{{formField.name}}</mat-label>
                                <mat-select
                                  [placeholder]="formField.name"
                                  [name]="formField.name"
                                  [required]="formField.options.length > 0 ? formField.required : false"
                                  [(ngModel)]="postObj[formField.model]"
                                  #fIndex="ngModel"
                                  [disabled]="formField.disabled"
                                  (selectionChange)="onDropDownChange(formField, i)"
                                  [multiple]="formField.multiple"
                                  >
                                  <mat-option
                                    *ngFor="let option of formField.options"
                                    [value]="formField.value ? option[formField.value] : option"
                                    >
                                    {{ formField.display ? option[formField.display] : option }}
                                  </mat-option>
                                </mat-select>
                                <div *ngIf="fIndex.invalid && fIndex.touched">
                                  <mat-error *ngIf="fIndex.hasError('required')">{{ formField.name }} is required*</mat-error>
                                </div>
                              </mat-form-field>
                            </div>
                          </ng-container> -->
                          <!-- <ng-container *ngIf="formField.type === 'select'">
                          <div fxLayout="row" fxFlex="100%" class="mb-10">
                            <div class="input-title" *ngIf="label" [ngStyle]="{ 'padding-left': i % formField.cols == 0 ? '0' : '10px' }">
                              <span>{{ formField.name }}</span>
                            </div>
                            <mat-form-field appearance="outline" class="col-md-2 moneytor-input">
                              <mat-select
                                [placeholder]="formField.name"
                                [name]="formField.name"
                                [required]="formField.required"
                                [(ngModel)]="formField.column === 'fieldJSON1' ? postObj.fieldJSON1[formField.model] : postObj[formField.model]"
                                #fIndex="ngModel"
                                [disabled]="formField.disabled"
                                (selectionChange)="onDropDownChange(formField, i)"
                                >
                                <mat-option
                                  *ngFor="let option of formField.options"
                                  [value]="formField.value ? option[formField.value] : option"
                                  >
                                  {{ formField.display ? option[formField.display] : option }}
                                </mat-option>
                              </mat-select>
                              <div *ngIf="fIndex.invalid && fIndex.touched">
                                <mat-error *ngIf="fIndex.hasError('required')">{{ formField.name }} is required*</mat-error>
                              </div>
                            </mat-form-field>
                          </div>
                        </ng-container> -->
                        @if (formField.type === 'date') {
                          <mat-form-field class="moneytor-input p-0 mb-15">
                            <mat-label>{{ formField.name }}</mat-label>
                            <input
                              matInput
                              [placeholder]="formField.label"
                              [(ngModel)]="postObj[formField.model]"
                              [name]="formField.name"
                              [required]="formField.required"
                              #dIndex="ngModel"
                              [placeholder]="formField.placeHolder"
                              [matDatepicker]="i"
                              (dateChange)="inputChange(formField)"
                              />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="i"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #i></mat-datepicker>
                          </mat-form-field>
                          @if (dIndex.invalid && dIndex.touched) {
                            <div>
                              @if (dIndex.hasError('required')) {
                                <mat-error class="dateError"
                                  >{{ formField.name }} is required*</mat-error
                                  >
                                }
                              </div>
                            }
                          }
                          @if (formField.name === 'Neo4J Columns') {
                            <h3 class="p-20">Neo4J Columns</h3>
                          }
                          @if (formField.name === 'BaseConfigs') {
                            <div class="d-flex ta-r">
                              <mt-btn
                                class="nobg addmorebtn p-0"
                                (onAction)="addnewRelation()"
                                >
                                <mat-icon>add_circle</mat-icon>
                              </mt-btn>
                              <mt-btn
                                class="nobg text-danger p-0"
                                (onAction)="removeLastRelations()"
                                >
                                <mat-icon>remove_circle</mat-icon>
                              </mt-btn>
                            </div>
                          }
                        </div>
                      }
                    }
                    @if (showImage) {
                      <img [src]="imgSource" alt="Signature" class="signClass" />
                    }
                  </div>
                </div>

                <div class="mt-form-button-container">
                  <div
                    class="flexRow p-10"
                    [ngClass]="btnClass ? 'd-flex justify-content-center error' : ''"
                    >
                    @for (button of buttons; track button) {
                      @if (button.value === 'deactivate') {
                        <mt-btn
                          (onAction)="onFormAction($safeNavigationMigration(button?.submit), $safeNavigationMigration(button?.value))"
                          [ngClass]="button.class"
                          >{{ "Deactivate" }}</mt-btn
                          >
                        }
                      }
                      @for (button of buttons; track button) {
                        @if (button.value === 'reset') {
                          <mt-btn
                            (onAction)="onFormAction($safeNavigationMigration(button?.disabled), $safeNavigationMigration(button?.value))"
                            [ngClass]="button.class"
                            >{{ getBtnLabel(button) }}</mt-btn
                            >
                          }
                        }
                        <!-- <span class="sp"></span> -->
                        @for (button of buttons; track button) {
                          @if (button.value !== 'deactivate' && button.value !== 'reset') {
                            <mt-btn
                              [ngClass]="button.class"
                              [disabled]="mtCommonForm.invalid"
                              (onAction)="onFormAction($safeNavigationMigration(button?.submit), $safeNavigationMigration(button?.value))"
                              >{{ getBtnLabel(button) }}</mt-btn
                              >
                            }
                          }
                        </div>
                      </div>
                    </form>
